import React, { Component } from 'react';
import ContractBase from './ContractBase';

class RecupPreview extends Component {
    state = {  }
    render() {
        return (
            <ContractBase
                opType="RECUP"
                {...this.props}
            />
        );
    }
}

export default RecupPreview;